<template>
    <InfoPageLayout title="Privacy Policy" :content="privacyPolicy?.content" />
</template>

<script setup>
import InfoPageLayout from '@/components/layouts/InfoPageLayout.vue';
import { ref } from 'vue';
import { getPrivacyPolicy } from '@/services/pageService';

const privacyPolicy = ref(null);

getPrivacyPolicy().then(response => {
    privacyPolicy.value = response.data;
});
</script>
